module.exports = __webpack_public_path__ + "img/gate.4a0b8b3a.png";